import { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto";

export enum Role {
  admin = "ad",
  teamLead = "tl",
  booking = "bk",
  hr = "hr",
  operation = "op",
  accounting = "ac",
}

export const RoleMap: Record<Role, string> = {
  [Role.admin]: "Admin",
  [Role.teamLead]: "Team Lead",
  [Role.booking]: "Booking",
  [Role.hr]: "HR",
  [Role.operation]: "Operation",
  [Role.accounting]: "Accounting",
};

export enum MenuSection {
  dispatchers = "dispatchers",
  drivers = "drivers",
  owners = "owners",
  trucks = "trucks",
}

export enum RoleAction {
  view = "view",
  edit = "edit",
  delete = "delete",
}

export enum NavigationItem {
  account = "account",
  dashboard = "dashboard",
  chat = "chat",
  coordinators = "coordinators",
  dispatchers = "dispatchers",
  drivers = "drivers",
  carriers = "carriers",
  company = "company",
  customers = "customers",
  facilities = "facilities",
  orders = "orders",
  owners = "owners",
  trips = "trips",
  trucks = "trucks",
  logs = "logs",
  users = "users",
  billing = "billing",
}

export const NavigationPermissionMap: Record<NavigationItem, DispatcherPermissionValue[]> = {
  [NavigationItem.account]: [],
  [NavigationItem.dashboard]: [],

  [NavigationItem.chat]: [DispatcherPermissionValue.ViewChat],

  [NavigationItem.coordinators]: [],
  [NavigationItem.dispatchers]: [DispatcherPermissionValue.ViewDispatchers],

  [NavigationItem.drivers]: [],
  [NavigationItem.carriers]: [],
  [NavigationItem.company]: [DispatcherPermissionValue.ViewCompanies],

  [NavigationItem.customers]: [],
  [NavigationItem.facilities]: [],
  [NavigationItem.orders]: [DispatcherPermissionValue.ViewOrders],

  [NavigationItem.owners]: [],
  [NavigationItem.trips]: [DispatcherPermissionValue.ViewTripInfo],

  [NavigationItem.trucks]: [DispatcherPermissionValue.ViewTrucks],

  [NavigationItem.logs]: [],
  [NavigationItem.users]: [DispatcherPermissionValue.ViewUsers],

  [NavigationItem.billing]: [DispatcherPermissionValue.AccessToBilling],
};
